import { RouteComponentProps } from "@reach/router";
import { FunctionComponent } from "react";
import { User, UserType } from "./types";

interface RouteGuardProps {
  currentUser: User | null;
  component: FunctionComponent<RouteComponentProps>;
  allowedUserTypes: UserType[];
  path: string;
}

export const RouteGuard: FunctionComponent<RouteGuardProps> = ({
  currentUser,
  component: RouteComponent,
  allowedUserTypes,
  path
}) => {
  return allowedUserTypes.includes(currentUser?.userType as UserType) ? (
    <RouteComponent path={path} />
  ) : (
    <div>NOT ALLOWED</div>
  );
};

const defaultLinkMap: Record<UserType, string> = {
  BCP_ADMIN: "/app-service"
};

export const getDefaultLink: (user: User | null) => string = user =>
  user?.userType ? defaultLinkMap[user.userType] || "/" : "/";
